import { render, staticRenderFns } from "./bonus10.vue?vue&type=template&id=802db98a&scoped=true&"
import script from "./bonus10.vue?vue&type=script&lang=js&"
export * from "./bonus10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802db98a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('802db98a')) {
      api.createRecord('802db98a', component.options)
    } else {
      api.reload('802db98a', component.options)
    }
    module.hot.accept("./bonus10.vue?vue&type=template&id=802db98a&scoped=true&", function () {
      api.rerender('802db98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/bonusConfig/bonus10.vue"
export default component.exports